// @mui
import { styled } from "@mui/material/styles";
import { ListItemIcon, ListItemButton } from "@mui/material";

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 38,
  position: "relative",
  textTransform: "capitalize",
  fontSize: "1 rem",
  // fontSize: theme.typography.h3.fontSize,
  marginBottom: 5,
  color: theme.palette.grey[500],
  borderRadius: theme.shape.borderRadius,
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 24,
  height: 24,
  color: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
